/*
 * @Author: your name
 * @Date: 2021-06-23 10:00:10
 * @LastEditTime: 2023-11-02 11:01:10
 * @LastEditors: LAPTOP-JM4BAR46
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\src\api\index.js
 */
import commonApi from './commonApi/index';
import userApi from './userApi/index';
import userGroupApi from './userGroupApi/index';
import testApi from './testApi';
import tenantApi from './tenantApi/index';
import roleApi from './roleApi/index';
import authApi from './authApi/index';
import channelApi from './channelApi/index';
import goodsApi from './goodsApi/index';
import settingApi from './settingApi/index';
import messageApi from './messageApi/index';
import stockApi from './stockApi/index';
import baseDataApi from './baseDataApi/index';
import worksheetApi from './worksheetApi/index';
import logisticApi from './logisticApi/index';
import menuApi from './menuApi/index';
import simpApi from './simpApi/index';
import orderApi from './orderApi';
import strategyApi from './strategyApi';
import tagsApi from './tagsApi';
import promotionApi from './promotionApi';
import afterApi from './afterApi';
import financeApi from './financeApi'; // 财务
import reportApi from './reportApi'; // 报表
import importApi from './importApi'; // 导入
import thirdApi from './thirdApi';
import purchaseApi from './purchaseApi'; // 采购
import quotationApi from './quotationApi'; // 报价
import billApi from './billApi'; // 报价
import thirdReturnApi from './thirdReturnApi'; // 退货单
import  workorderApi  from  "./workorderApi"
import  serviceItem  from  "./serviceItem"
import  funConfigApi from  "./funConfigApi"
import  waveApi from  "./waveApi"
import  systemOnlineNtfApi from  "./systemOnlineNtfApi"

export {
  commonApi,
  userApi,
  userGroupApi,
  testApi,
  tenantApi,
  roleApi,
  authApi,
  channelApi,
  goodsApi,
  settingApi,
  messageApi,
  stockApi,
  baseDataApi,
  worksheetApi,
  logisticApi,
  menuApi,
  simpApi,
  orderApi,
  strategyApi,
  tagsApi,
  promotionApi,
  afterApi,
  financeApi,
  reportApi,
  importApi,
  thirdApi,
  purchaseApi,
  quotationApi,
  billApi,
  thirdReturnApi,
  workorderApi,
  serviceItem,
  funConfigApi,
  waveApi,
  systemOnlineNtfApi,
};
